export default "__VITE_PUBLIC_ASSET__79167bb8__"